<template>
  <!-- 国家及地区英文 -->
  <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
    <a-row>
      <a-col :span="8">
        <form-select
          label="语言英文"
          v-model:value="params.langEn"
          :showSearch="true"
        >
          <a-select-option
            :value="item.langEn"
            v-for="(item, key) in lang"
            :key="key"
          >
            {{ item.langEn }}
          </a-select-option>
        </form-select>
      </a-col>
      <a-col :span="6">
        <form-select
          label="语言中文"
          v-model:value="params.langCn"
          :showSearch="true"
        >
          <a-select-option
            :value="item.langCn"
            v-for="(item, key) in lang"
            :key="key"
          >
            {{ item.langCn }}
          </a-select-option>
        </form-select>
      </a-col>
      <a-col :span="6">
        <form-select label="是否启动" v-model:value="params.enabled">
          <a-select-option key="1" value="1">
            关
          </a-select-option>
          <a-select-option key="0" value="0">
            开
          </a-select-option>
        </form-select>
      </a-col>
      <a-col :span="4">
        <a-button type="primary" class="mr10" @click="changePage(1)"
          >查询</a-button
        >
      </a-col>
    </a-row>
  </a-form>
  <EventAlert v-if="visible" />
</template>
<script>
import { inject, reactive, toRefs } from 'vue'
import EventAlert from '../../List/components/EventAlert.vue'
export default {
  components: {
    EventAlert
  },
  setup() {
    const state = inject('state')
    const searchState = reactive({
      ok() {
        const { setAttrs, setEmpty } = state
        setAttrs('visible', true)
        setEmpty()
      }
    })
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      ...toRefs(searchState),
      ...toRefs(state)
    }
  }
}
</script>
